import { z } from 'zod';

import { chatbotConfigSchema, chatThemeConfigSchema } from '../chatContract';
import { workingHoursSchema } from '../organizationContract';
import type { EndpointContractGroup } from '../schemaUtils';

export const completionsConfigResponseSchema = z.object({
  agentName: z.string(),
  chatbotConfig: chatbotConfigSchema.nullish(),
  themeConfig: chatThemeConfigSchema.nullish(),
  workingHours: workingHoursSchema.nullish(),
  captchaSiteKey: z.string().nullish(),
  showToolActivity: z.boolean().optional(),
  showReasoning: z.boolean().optional(),
});

export type CompletionsConfigResponse = z.infer<
  typeof completionsConfigResponseSchema
>;

export const embedAllowedResponseSchema = z.object({
  allowed: z.boolean(),
});

export type EmbedAllowedResponse = z.infer<typeof embedAllowedResponseSchema>;

/**
 * Schema definition for all completions endpoints
 */
export const completionsApiSchemas = {
  completions: {
    embedAllowed: {
      path: '/chats/:chatId/embed-allowed',
      method: 'GET',
      schema: {
        params: z.object({
          chatId: z.string(),
        }),
        querystring: z.object({
          pageUrl: z.string().min(1),
        }),
        response: {
          200: embedAllowedResponseSchema,
        },
      },
    },
    config: {
      path: '/chats/:chatId/config',
      method: 'GET',
      schema: {
        params: z.object({
          chatId: z.string(),
        }),
        response: {
          200: completionsConfigResponseSchema,
        },
      },
    },
    callouts: {
      path: '/chats/:chatId/callouts',
      method: 'POST',
      schema: {
        params: z.object({
          chatId: z.string(),
        }),
        body: z.object({
          context: z
            .object({
              currentUrl: z.string().optional(),
              browserLanguages: z.array(z.string()).optional(),
              pageLanguage: z.string().optional(),
            })
            .optional(),
        }),
        response: {
          200: z.object({
            messages: z.array(z.string()),
          }),
        },
      },
    },
  },
} satisfies EndpointContractGroup;
